import ApiService from './api.service'

const DepartmentsService = {
	getDepartments:  function () {
		return  ApiService.post(`/department/list`, {});
	},
	getDepartmentsWithRequisite:  function () {
		return  ApiService.post(`/department/saldo-departments`);
	},
	updateOrCreateDepChildById:  function (payload) {
		return  ApiService.post('/department/add-or-update', payload);
	},
	deleteDep:  function (depId) {
		return  ApiService.delete(`/department/delete/${depId}`);
	},
	fetchWholesaleDepartments: function () {
		return ApiService.post(`/department/list-whole`);
	}
};

export default DepartmentsService
